import { render, staticRenderFns } from "./Story1.vue?vue&type=template&id=0c9585de&scoped=true&lang=pug"
import script from "./Story1.vue?vue&type=script&lang=js"
export * from "./Story1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9585de",
  null
  
)

export default component.exports